import {gql} from '@apollo/client';
import cx from 'classnames';
import Image from 'next/image';
import NextLink from 'next/link';

import {Button, Text} from '#component/base';
import {HoverEffect} from '#component/util';
import {sprinkles} from '#style/sprinkles';

import {LearningResourceCardProps} from './LearningResourceCard.types';

import * as css from './LearningResourceCard.css';

export const learningResourceCardFragment = gql`
  fragment LearningResourceCardFragment on LearningResource {
    id
    duration
    imageUrl
    title
    type
  }
`;

export const LearningResourceCard = ({
  className,
  duration,
  headline = '',
  href = '',
  imageUrl = '',
  type = '',
  ...otherProps
}: LearningResourceCardProps) => {
  const renderedDuration = duration ? `${duration} min` : '';
  const renderedBadge = `${renderedDuration}${renderedDuration && type ? ' • ' : ''}${type || ''}`;

  return (
    <NextLink passHref href={href}>
      <a className={cx(css.root, className)} aria-label={headline} {...otherProps}>
        <div className={css.imageContainer}>
          <Image
            alt=""
            aria-hidden
            className={css.image}
            layout="fill"
            objectFit="cover"
            src={imageUrl}
          />
          <HoverEffect />
          {renderedBadge && (
            <Text className={css.badge} color="burgundy" variant="label">
              {renderedBadge}
            </Text>
          )}
        </div>

        <div
          className={sprinkles({flex: 'flex', gap: 16, content: 'between', pT: [24, 32], pB: 32})}>
          <Text clamp={3} color="burgundy" variant="heading3">
            {headline}
          </Text>

          <Button aria-hidden as="span" icon="ArrowRight" />
        </div>
      </a>
    </NextLink>
  );
};
